import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { GET_TAG,GET_TAG_MASTER,GET_POS,GET_POS_REASONS_WITH_MATERIAL,GET_POS_EMP_DATA, REQUIRED_DOCUMENTS, SAVE_COMPETITON_MAPPING, COMPETITION_MAPPING_DATA, FETCH_SITE_NAME } from "./type";

export const getTagDelivery = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.getTagDelivery}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_TAG,
      payload: data.response.data,
    });
    return true;
  }
};
export const getPosShipment = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.getPosRequirement}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_POS,
      payload: data.response.data,
    });
    return true;
  }
};
export const getTags = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.getTags}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_TAG_MASTER,
      payload: data.response.data,
    });
    return true;
  }
};

export const postTagDelivery = (data) => async (dispatch) => {
  // console.log(data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.postTagDelivery}`
  );
  if (res?.data?.response?.status) {
    return res?.data?.response?.status;
  } else return false;
};

export const updateStatus = (siteId, stageId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    "",
    `${Config.installation.statusUpdate}?site_id=${siteId}&stage_id=${stageId}`
  );
  if (res?.data?.response?.status) {
    return true;
  } else return false;
};

export const updateStatusPos = (payload) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    payload,
    `${Config.installation.statusUpdatePos}`
  );
  if (res?.data?.response?.status) {
    return true;
  } else return false;
};

export const getPosShipmentAndReasons = (id,type) => async (dispatch) => {
  dispatch({type: GET_POS_REASONS_WITH_MATERIAL, payload: null,});
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.getPosShipmentAndReasons}?site_id=${id}&type=${type}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_POS_REASONS_WITH_MATERIAL,
      payload: data.response.data,
    });
    return true;
  }
};

export const replaceOrReturnPos = (payload) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    payload,
    `${Config.installation.replaceOrReturnPos}`
  );
  if (res?.data?.response?.status) {
    return true;
  } else return false;
};

export const fetchEmployeePosDevices = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.fetchPosDevicesForEmp}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_POS_EMP_DATA,
      payload: data.response.data,
    });
    return true;
  }
};

export const getRequiredDocumentsDropdown = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.requiredDocumentDropdown}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: REQUIRED_DOCUMENTS,
      payload: data.response.data,
    });
    return true;
  }
};

export const saveCompetitionMapping = (payload) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    payload,
    `${Config.installation.saveCompetitionMapping}`
  );
  console.log("RESPONSE: ", res)
  if (res) {
    return res;
  } 
};

export const getCompetitionMappingData = (page, filterData) => async (dispatch) => {
  let  url = `${Config.installation.competitionMappingList}?page=${page}`;
  if(filterData?.created_by_name){
    url += `&created_by=${filterData?.created_by_name}`;
  }
  if(filterData?.site_name){
    url += `&site_name=${filterData?.site_name}`;
  }
  if(filterData?.solution_type){
    url += `&solution_type=${filterData?.solution_type}`;
  }
  if(filterData?.city){
    url += `&city=${filterData?.city}`;
  }
  const res = await callWebService(
    callTypes.get,
    "",
    url
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: COMPETITION_MAPPING_DATA,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchSiteNameUsingLatLong = (lat, lng) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.fetchSiteNameUsingLatLong}?latitude=${lat}&longitude=${lng}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: FETCH_SITE_NAME,
      payload: data.response.data,
    });
    return true;
  }
};
